import { EXTERNAL_BASE_URL, MOCK_API } from '@/constants'

// In dev with mock: use local Next.js API routes (/api/...)
// In production: use the full external API URL
export const API_BASE = MOCK_API ? '/api' : EXTERNAL_BASE_URL || ''

export const API = {
  // auth
  LOGIN: '/login',
  LOGOUT: '/logout',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  EMAIL_VERIFY: '/email/verify',
  // news
  NEWS_FILTER: '/news/filter',
  NEWS: '/news',
  // documents
  DOCUMENTS_TREE: '/documents/tree',
  DOCUMENTS_CONTENT: '/documents/content',
  DOCUMENTS_DOWNLOAD: '/documents/download',
  // privacy
  PRIVACY_CURRENT: '/privacy-instances/current',
  PRIVACY_ACCEPT: '/privacy-instances/accept'
} as const

export const USER = {
  PROFILE: '/profile'
} as const
